import { render, staticRenderFns } from "./DropdownField.vue?vue&type=template&id=0124eef1&lang=pug"
import script from "./DropdownField.vue?vue&type=script&lang=js"
export * from "./DropdownField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports